import { Component, Input, OnInit } from '@angular/core';
import {Dictionary} from 'highcharts';
import {animate, state, trigger, transition, style} from '@angular/animations';

export interface TableSection {
  title: string;
  expanded?: boolean;
  expandCollapse?: boolean;
  headers?: string[];
  rows: (string[] | MergedRow | TitleRow)[];
}

export interface MergedRow {
  values: string[];
}

export interface TitleRow {
  type: 'title';
  value: string;
  colspan?: number;
}

@Component({
  selector: 'app-expand-collapse-table',
  templateUrl: './expand-collapse-table.component.html',
  styleUrls: ['./expand-collapse-table.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state('expanded', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      state('collapsed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      transition('expanded <=> collapsed', [
        animate('500ms ease-in-out')
      ])
    ])
  ]
})
export class ExpandCollapseTableComponent implements OnInit{

  @Input() data: TableSection[] = [];
  @Input() style: Dictionary<any>;

  ngOnInit(): void {
  }

  toggleSection(section: any) {
    section.expanded = !section.expanded;
  }

  toggleSubheader(subheader: any) {
    subheader.collapsed = !subheader.collapsed;
  }

  isSubheader(row: any): boolean {
    return row.type === 'subheader';
  }

  isRow(row: any): boolean {
    return row.type === 'row';
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

}

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'subGroups' })
export class SubGroupsPipe implements PipeTransform {
  transform(rows: any[]): any[] {
    const groups = [];
    let currentGroup = null;
    for (const row of rows) {
      if (row.type === 'subheader') {
        currentGroup = { subheader: row, rows: []};
        groups.push(currentGroup);
      } else if (currentGroup) {
        currentGroup.rows.push(row);
      }
    }
    return groups;
  }
}

@Pipe({ name: 'mergedCells' })
export class MergedCellsPipe implements PipeTransform {
  transform(values: string[]): { value: string; colspan: number }[] {
    if (!Array.isArray(values)) return [];

    const result: { value: string; colspan: number }[] = [];
    let prev: { value: string; colspan: number } | null = null;

    for (const val of values) {
      if (prev && prev.value === val) {
        prev.colspan += 1;
      } else {
        prev = { value: val, colspan: 1 };
        result.push(prev);
      }
    }

    return result;
  }
}
